'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Facebook = require('@deliveroo/icon-set/react/Facebook');

var _Facebook2 = _interopRequireDefault(_Facebook);

var _Instagram = require('@deliveroo/icon-set/react/Instagram');

var _Instagram2 = _interopRequireDefault(_Instagram);

var _Twitter = require('@deliveroo/icon-set/react/Twitter');

var _Twitter2 = _interopRequireDefault(_Twitter);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _FooterCard = require('../FooterCard');

var _FooterCard2 = _interopRequireDefault(_FooterCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'footer': 'ccl-8db0e82a827baf39',
  'content': 'ccl-520d3ad4458baf0a',
  'primary': 'ccl-472f8c75ffc4bdc7',
  'secondary': 'ccl-128a89a49a9ff00b',
  'social': 'ccl-ec63940eb2cffb38',
  'socialItem': 'ccl-2e8c38206385e366',
  'link': 'ccl-f65f6247029a98f7',
  'twitter': 'ccl-a51c6c722d06b887',
  'facebook': 'ccl-f41807dbd86452ba',
  'instagram': 'ccl-d140080a23d1f6fb'
};


var iconMap = {
  facebook: _Facebook2.default,
  twitter: _Twitter2.default,
  instagram: _Instagram2.default
};

/**
 * A global Navigation Footer component for Consumer
 */
function NavFooter(_ref) {
  var footerSections = _ref.footerSections,
      socialLinks = _ref.socialLinks,
      copyright = _ref.copyright;

  return _react2.default.createElement(
    'footer',
    { className: styles.footer },
    _react2.default.createElement(
      'div',
      { className: styles.content },
      _react2.default.createElement(
        'nav',
        { className: styles.primary },
        footerSections.map(function (_ref2) {
          var heading = _ref2.heading,
              links = _ref2.links,
              children = _ref2.children;
          return _react2.default.createElement(
            _FooterCard2.default,
            { key: heading, heading: heading, links: links },
            children
          );
        })
      ),
      _react2.default.createElement(
        'nav',
        { className: styles.secondary },
        _react2.default.createElement(
          'ul',
          { className: styles.social },
          socialLinks.map(function (_ref3) {
            var title = _ref3.title,
                url = _ref3.url,
                icon = _ref3.icon;
            return _react2.default.createElement(
              'li',
              { key: url, className: styles.socialItem },
              _react2.default.createElement(
                'a',
                {
                  href: url,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  title: title,
                  className: (0, _classnames2.default)(styles.link, styles[icon])
                },
                _react2.default.createElement(_Icon2.default, { component: iconMap[icon], size: 24 })
              )
            );
          })
        ),
        _react2.default.createElement(
          _P2.default,
          { color: 'grey', size: 'small' },
          copyright
        )
      )
    )
  );
}

NavFooter.displayName = 'NavFooter';
NavFooter.propTypes = {
  /**
   * An array of footer sections, containing headings, links and optional child content
   */
  footerSections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    heading: _propTypes2.default.string.isRequired,
    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      url: _propTypes2.default.string.isRequired
    })),
    children: _propTypes2.default.node
  })).isRequired,

  /**
   * An array of social media links
   */
  socialLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.oneOf(['facebook', 'twitter', 'instagram']).isRequired
  })).isRequired,

  /**
   * A copyright declaration string with current year
   */
  copyright: _propTypes2.default.string.isRequired
};